import styled from '@emotion/styled'
import { colors } from 'utils/colors'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SInfoBlockWrapper = styled.div`
  display: block;
  margin: 0 var(--p-content);
`

export const SCardsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  position: relative;
  padding: 43px 0;
  margin-top: 2rem;
  margin-bottom: 7.5rem;

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    width: calc(100% + 100px);
    top: ${pxToRem(-190)}rem;
    left: ${pxToRem(-50)}rem;
    bottom: 0;
  }

  @media ${BREAKPOINTS.MD.max} {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;

    &:before {
      top: -5rem;
      bottom: 40%;
    }
  }
`

export const SCard = styled.div`
  /* width: 25%; */
  display: flex;
  flex-direction: column;

  & svg {
    color: ${colors.blue[500]};
    margin-bottom: 1rem;
    width: 2.5rem;
    height: 2.5rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    width: 50%;
    margin-bottom: ${pxToRem(20)}rem;
  }
  @media ${BREAKPOINTS.MD.max} {
    width: 75%;
    margin-bottom: ${pxToRem(20)}rem;
  }
`
